import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WorkPage from "../pages/work/page";
import WorkDetailPage from "../pages/work/detail/page";
import InsightsPage from "../pages/insights/page";
import InsightDetailPage from "../pages/insights/detail/page";
import ExpertisePage from "../pages/expertise/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/work",
    element: <WorkPage />,
  },
  {
    path: "/work/:slug",
    element: <WorkDetailPage />,
  },
  {
    path: "/insights",
    element: <InsightsPage />,
  },
  {
    path: "/insights/:slug",
    element: <InsightDetailPage />,
  },
  {
    path: "/expertise",
    element: <ExpertisePage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;